module.exports = __webpack_public_path__ + "img/56.cf5a60d4.svg";